/* eslint semi:0 */
import 'core-js'
import '../../jsCore/application/bootstrap_common'
import '../../components/body/uaBodyClassModifier'
import mountHeaderComponents from '../../components/header/headerComponents'
import initSchedule from '../../components/schedule/scheduleHomepageContainer'
import localeCookieInitializer from '../../jsCore/organizedByType/initializers/localeCookieInitializer'
import initAnalytics from '../../jsCore/organizedByType/initializers/analyticsInitializer'
import mountWritersLoginButton from '../../components/static_pages_content/writersLoginButton'
import trackAnalyticsClickEvents from '../../components/track_analytics_click_events/trackAnalyticsClickEvents'
import initAdblockDetectorProvider from '../../jsCore/providers/ads/adblockDetectorProvider'
import { init as initUserProfilePage } from '../../users/users'
import initGoogleAds from '../../jsCore/organizedByType/initializers/ads/initGoogleAds'
import initPostMetadataStats from '../../components/post_metadata/postMetadataContainer'
import { initCommonComponents } from '../common/common'
import { initEiExternalScripts } from '../../jsCore/organizedByType/initializers/initEiExternalScripts'
import { initTheDuelExternalScripts } from '../../jsCore/organizedByType/initializers/initTheDuelExternalScripts'
import { getVideoAdsTag } from '../../jsCore/organizedByType/vms/ads/videoAdTag'
import { register } from '../../components/viewability/viewbilityTracker'
import { LinksGroupContainer } from '../../../../../lib/provolution/components/links_group/presentation/views/linksGroup.container'
import { renderReact } from 'hypernova-react'
import initBrowsi from '../../jsCore/organizedByType/initializers/initBrowsi'

initGoogleAds()
initAnalytics()
initAdblockDetectorProvider()
initBrowsi()
localeCookieInitializer()
mountHeaderComponents()
initSchedule()
mountWritersLoginButton()
trackAnalyticsClickEvents()
initUserProfilePage()
initPostMetadataStats()
initCommonComponents()
initEiExternalScripts()
initTheDuelExternalScripts()
getVideoAdsTag()
register('.pagination-controls')
register('.feed-links-container')
renderReact('LinksGroupContainer', LinksGroupContainer)



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/entry_points/feedAndStaticPages/feedAndStaticPages.js